import { takeLatest } from "redux-saga/effects";
import { actionTypes } from "../actions";
import { fetchCfarOffersSaga } from "./fetchCfarOffersSaga";

export function* watchGetCfarOffer() {
  yield takeLatest(actionTypes.FETCH_CFAR_OFFERS, fetchCfarOffersSaga);
}
